import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../../AbstractElements";
import { DetailedCourseTitle, LearningTitle } from "../../../../Constants/Constants";
import LearningFilter from "../Common/LearningFilter";
import BlogDetails from "./BlogDetails";

const DetailedCourseContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={DetailedCourseTitle} parent={LearningTitle} />
      <Container fluid>
        <Row>
          <BlogDetails />
          <LearningFilter />
        </Row>
      </Container>
    </>
  );
};
export default DetailedCourseContainer;
